import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { forkJoin } from 'rxjs';

import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { UiTagComponent } from '../../../shared/components/ui-tag/ui-tag.component';
import {
  ConfiguracaoColunasModalComponent,
  ColunaConfiguracao,
} from '../../../shared/components/configuracao-colunas-modal/configuracao-colunas-modal.component';

import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '../../../shared/enums/usuario/permissao.enum';
import { StatusOrdemProducaoBadge, StatusOrdemProducaoDescricao } from '../../../shared/enums/suprimentos/status-ordem-producao.enum';
import { TipoIntegracaoEnum, TipoIntegracaoIndicador } from '../../../shared/enums/suprimentos/tipo-integracao.enum';

import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { UtilService } from '../../../shared/services/util.service';
import { OrdemProducaoService } from '../../../shared/services/apis/suprimentos/ordem-producao.service';
import { OrdemProducaoOrquestradorService } from '../../../shared/services/apis/orquestrador-suprimentos/ordem-producao-orquestrador.service';
import { EtiquetaLookupService } from '../../../shared/services/apis/etiqueta/etiqueta-lookup.service';
import { LookupService } from '../../../shared/services/apis/produto/produto-lookup.service';
import { OrdemProducaoListStruct } from '../../../shared/services/structs/suprimentos/ordem-producao-list.struct';
import { OrdemProducaoDetalheStruct } from '../../../shared/services/structs/suprimentos/ordem-producao-detalhe.struct';
import { TagProducaoStruct } from '../../../shared/services/structs/suprimentos/tag-producao.struct';
import { OrdemProducaoListaRequest } from '../../../shared/services/requests/suprimentos/ordem-producao-lista.request';
import { OrdemProducaoEstoqueExcluirRequest } from '../../../shared/services/requests/suprimentos/ordem-producao-estoque-excluir.request';
import { LancarEstoqueOrdemProducaoItemRequest } from '../../../shared/services/requests/suprimentos/lancar-estoque-ordem-producao-item.request';
import { LocalizacaoEstoque } from '../../../shared/services/models/produto/localizacao-estoque.model';
import { ListaPrecoStruct } from '../../../shared/services/structs/produto/lista-preco.struct';
import { ProdutoListStruct } from '../../../shared/services/structs/produto/produto-list.struct';
import { EtiquetaLookupItemStruct } from '../../../shared/services/structs/etiqueta/etiqueta-lookup-item.struct';

import { AlterarTagsOrdemProducaoDialogComponent } from './dialogs/alterar-tags-ordem-producao-dialog/alterar-tags-ordem-producao-dialog.component';
import { OrdensRelacionadasDialogComponent } from './dialogs/ordens-relacionadas-dialog/ordens-relacionadas-dialog.component';
import { LancarEstoqueLoteOrdemProducaoDialogComponent } from './dialogs/lancar-estoque-lote-ordem-producao-dialog/lancar-estoque-lote-ordem-producao-dialog.component';
import { LancarEstoqueOrdemProducaoDialogComponent } from '../ordem-producao-detalhe/dialogs/lancar-estoque-ordem-producao-dialog/lancar-estoque-ordem-producao-dialog.component';
import { ExcluirEstoqueOrdemProducaoDialogComponent } from '../ordem-producao-detalhe/dialogs/excluir-estoque-ordem-producao-dialog/excluir-estoque-ordem-producao-dialog.component';
import { ImpressaoNecessidadeMateriaisOrdemProducaoDialogComponent } from '../../../shared/components/impressao-necessidade-materiais-ordem-producao-dialog/impressao-necessidade-materiais-ordem-producao-dialog.component';
import {
  ImprimirEtiquetasDialogComponent,
  ImprimirEtiquetasDialogData,
} from '../../../shared/components/imprimir-etiquetas-dialog/imprimir-etiquetas-dialog.component';

@Component({
  selector: 'app-ordem-producao-lista',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatCheckboxModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatTooltipModule,
    EmptyListComponent,
    LoadingBoxDefaultListComponent,
    SelectPesquisavelComponent,
    UiTagComponent,
  ],
  templateUrl: './ordem-producao-lista.component.html',
  styleUrls: ['./ordem-producao-lista.component.css'],
})
export class OrdemProducaoListaComponent implements OnInit, OnDestroy {
  public moduloEnum = ModuloEnum.Suprimentos;
  public funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_OrdemProducao;
  public permissaoEnum = PermissaoEnum;

  public model!: FormGroup;
  public _isLoading = false;

  public _dataSource = new MatTableDataSource<OrdemProducaoListStruct>();
  public selection = new SelectionModel<OrdemProducaoListStruct>(true, []);
  public _paginaAtual = 0;
  public _ultimaPagina = false;
  public _carregou = false;
  private _searchToken = 0;
  private _filtrosAvancadosAplicados: { listIdStatus: number[]; listIdTagProducao: number[] } = {
    listIdStatus: [],
    listIdTagProducao: [],
  };

  public listaTags: TagProducaoStruct[] = [];
  public listaStatus: { id: number; descricao: string }[] = [];
  public listaPreco: ListaPrecoStruct[] = [];
  public listaLocalizacaoEstoque: LocalizacaoEstoque[] = [];

  public podeInserir = false;
  public podeAlterar = false;
  /** Lançar estoque usa a permissão Inserir da OP. */
  public podeLancarEstoque = false;
  public podeExcluir = false;
  /** Permissão 189: só exclui o estoque da OP; lançar vale para quem pode inserir a ordem. */
  public podeExcluirEstoque = false;
  /** OP com lançar ou excluir estoque em andamento pelo menu da linha: spinner no botão de ações dela. */
  public idOrdemProducaoEmAcao: number | null = null;

  /**
   * "Seleção", "Número", "Código (SKU) - Descrição" e "Ações" não são ocultáveis (seção 3.3 da US).
   * As demais entram no modal de Configurar Colunas.
   */
  public todosCampos: ColunaConfiguracao[] = [
    { def: 'select', label: 'Seleção', visible: true, fixed: true },
    { def: 'numero', label: 'Número', visible: true, fixed: true },
    { def: 'pedidos', label: 'Pedidos', visible: true, fixed: false },
    { def: 'dataInicio', label: 'Data início', visible: true, fixed: false },
    { def: 'dataPrevistaTermino', label: 'Data prevista de término', visible: true, fixed: false },
    { def: 'produto', label: 'Código (SKU) - Descrição do produto', visible: true, fixed: true },
    { def: 'quantidade', label: 'Quantidade', visible: true, fixed: false },
    { def: 'unidade', label: 'Un', visible: true, fixed: false },
    { def: 'tags', label: 'Tags', visible: true, fixed: false },
    { def: 'status', label: 'Status', visible: true, fixed: false },
    { def: 'acoes', label: 'Ações', visible: true, fixed: true },
  ];

  public displayedColumns: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private ordemProducaoService: OrdemProducaoService,
    private ordemProducaoOrquestradorService: OrdemProducaoOrquestradorService,
    private etiquetaLookupService: EtiquetaLookupService,
    private lookupService: LookupService,
    private alertService: AlertService,
    private authService: AuthService,
    private utilService: UtilService,
    private dialog: MatDialog,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      pesquisa: [''],
      listIdStatus: [[]],
      listIdTagProducao: [[]],
    });

    // Sem bypass de master: o backend (AuthorizationHelper.VerifyRoleAccess) checa apenas
    // listaPermissoes, então liberar o botão para master faria a tela oferecer ação que a API
    // rejeita.
    const usuario = this.authService.getUserInfos();
    const permissoes: number[] = usuario?.listaPermissoes ?? [];
    this.podeInserir = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Inserir);
    this.podeAlterar = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Alterar);
    this.podeLancarEstoque = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Inserir);
    this.podeExcluir = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Excluir);
    this.podeExcluirEstoque = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_ExcluirEstoque);

    this.atualizarColunasVisiveis();
    this.carregarLookups();
    this.carregarFiltroSalvo();
    this.atualizarFiltrosAvancadosAplicados();
    this.pesquisar();
  }

  ngOnDestroy(): void {
    // Mantém o filtro ao navegar para o cadastro e voltar; limpa ao sair do módulo.
    this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, [
      '/suprimentos/ordem-producao/cadastrar',
    ]);
  }

  private carregarFiltroSalvo(): void {
    const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
    if (filtroSalvo) {
      this.model.patchValue(filtroSalvo);
    }
  }

  private carregarLookups(): void {
    this.ordemProducaoService.getLookup().subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.listaTags = res.tags ?? [];
        this.listaStatus = (res.status ?? []).map((s) => ({
          id: s.idStatusOrdemProducao ?? 0,
          descricao: s.nome,
        }));
      },
      error: (err) => this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error),
    });

    // Lista de preço e localizações de estoque, usadas só pelo diálogo de imprimir etiquetas (7.3).
    this.lookupService.getLookup().subscribe({
      next: (res) => {
        if (!res.isError) {
          this.listaPreco = res.listaPreco || [];
          this.listaLocalizacaoEstoque = res.listaLocalizacaoEstoque || [];
        }
      },
    });
  }

  // ── Busca e filtros ────────────────────────────────────────────────────────

  private montarRequest(): OrdemProducaoListaRequest {
    return {
      textoBusca: this.model.get('pesquisa')?.value ?? '',
      listIdStatus: this.model.get('listIdStatus')?.value ?? [],
      listIdTagProducao: this.model.get('listIdTagProducao')?.value ?? [],
      dataDe: null,
      dataAte: null,
      tamanhoPagina: null,
    };
  }

  public pesquisar(): void {
    this._isLoading = true;

    // Descarta a resposta se uma busca mais nova já foi disparada nesse meio-tempo (ex.: a busca
    // inicial do ngOnInit ainda em voo quando o usuário já filtrou) — sem isso, a resposta antiga
    // faz concat() por cima da lista já resetada pela busca nova, duplicando os registros.
    const token = ++this._searchToken;

    this.ordemProducaoOrquestradorService.getAll(this.montarRequest(), this._paginaAtual).subscribe({
      next: (res) => {
        if (token !== this._searchToken) return;
        this._isLoading = false;
        this._carregou = true;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        const lista = res.listaOrdemProducao ?? [];
        this._dataSource.data = this._dataSource.data.concat(lista);
        this._ultimaPagina = lista.length === 0 || this._dataSource.data.length >= res.totalRegistros;
      },
      error: (err) => {
        if (token !== this._searchToken) return;
        this._isLoading = false;
        this._carregou = true;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  /** Recomeça da primeira página, descartando o que já estava carregado. */
  public clickPesquisar(): void {
    this._paginaAtual = 0;
    this._dataSource.data = [];
    this._ultimaPagina = false;
    this.selection.clear();
    this.pesquisar();
  }

  public proximaPagina(): void {
    this._paginaAtual++;
    this.pesquisar();
  }

  public aplicarFiltros(): void {
    this.atualizarFiltrosAvancadosAplicados();
    this.clickPesquisar();
  }

  public limparFiltros(): void {
    this.model.patchValue({ pesquisa: '', listIdStatus: [], listIdTagProducao: [] });
    this.atualizarFiltrosAvancadosAplicados();
    this.clickPesquisar();
  }

  private atualizarFiltrosAvancadosAplicados(): void {
    this._filtrosAvancadosAplicados = {
      listIdStatus: this.model.get('listIdStatus')?.value ?? [],
      listIdTagProducao: this.model.get('listIdTagProducao')?.value ?? [],
    };
  }

  /**
   * O painel de Filtros Avançados edita o mesmo `model` usado de verdade pela busca — marcar um
   * checkbox já muda o valor ao vivo, mesmo sem clicar "Aplicar". Ao fechar o menu por qualquer
   * caminho (Cancelar, clique fora, Esc), descarta o rascunho voltando ao que foi realmente
   * aplicado da última vez (vazio, se nunca aplicou nada) — sem isso o painel fica "sujo" mesmo
   * cancelando.
   */
  public onFiltroMenuClosed(): void {
    this.model.patchValue(this._filtrosAvancadosAplicados);
  }

  public get qtdFiltrosAvancados(): number {
    const status = this.model.get('listIdStatus')?.value ?? [];
    const tags = this.model.get('listIdTagProducao')?.value ?? [];
    return (status.length > 0 ? 1 : 0) + (tags.length > 0 ? 1 : 0);
  }

  // ── Colunas ────────────────────────────────────────────────────────────────

  private atualizarColunasVisiveis(): void {
    this.displayedColumns = this.todosCampos.filter((c) => c.visible).map((c) => c.def);
  }

  public configurarColunas(): void {
    const dialogRef = this.dialog.open(ConfiguracaoColunasModalComponent, {
      maxWidth: '700px',
      data: { colunas: this.todosCampos },
    });

    dialogRef.afterClosed().subscribe((result: ColunaConfiguracao[]) => {
      if (result) {
        this.todosCampos = result;
        this.atualizarColunasVisiveis();
      }
    });
  }

  // ── Seleção ────────────────────────────────────────────────────────────────

  public isAllSelected(): boolean {
    return this._dataSource.data.length > 0 && this.selection.selected.length === this._dataSource.data.length;
  }

  public toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this._dataSource.data);
  }

  // ── Apresentação ───────────────────────────────────────────────────────────

  public classeBadgeStatus(idStatus: number): string {
    return StatusOrdemProducaoBadge[idStatus] ?? 'badge-cinza';
  }

  public nomeStatus(ordem: OrdemProducaoListStruct): string {
    return ordem.nomeStatus || StatusOrdemProducaoDescricao[ordem.idStatusOrdemProducao] || '';
  }

  // ── Integração de estoque ──────────────────────────────────────────────────

  /** Indicadores da coluna Status: a letra E só com o estoque lançado. */
  public integracoes(ordem: OrdemProducaoListStruct): { sigla: string; rotulo: string; cor: string }[] {
    const indicadores: { sigla: string; rotulo: string; cor: string }[] = [];
    if (ordem.isEstoqueLancado) {
      const estoque = TipoIntegracaoIndicador[TipoIntegracaoEnum.Estoque];
      indicadores.push({ sigla: estoque.sigla, rotulo: 'Estoque lançado', cor: estoque.cor });
    }
    return indicadores;
  }

  // ── Ações ──────────────────────────────────────────────────────────────────

  public novaOrdem(): void {
    this.router.navigate(['/suprimentos/ordem-producao/cadastrar']);
  }

  public visualizar(ordem: OrdemProducaoListStruct): void {
    this.router.navigate(['/suprimentos/ordem-producao', ordem.idOrdemProducao, 'visualizar']);
  }

  public editar(ordem: OrdemProducaoListStruct): void {
    if (ordem.isEstoqueLancado) {
      this.alertService.show('Atenção', 'Exclua o estoque para editar esta ordem.', AlertType.warning);
      return;
    }
    this.router.navigate(['/suprimentos/ordem-producao', ordem.idOrdemProducao, 'editar']);
  }

  /**
   * Seção 3.8 do handoff: OP com estoque lançado NUNCA é excluída sem excluir o estoque antes, não é
   * opcional. Um único diálogo de confirmação, sem checkbox: se a OP tem estoque lançado, o texto
   * já avisa que o estoque é excluído junto ao confirmar e pede a justificativa. O atalho exige as
   * duas permissões: excluir a ordem (item do menu) e excluir o estoque.
   */
  public excluir(ordem: OrdemProducaoListStruct): void {
    const temEstoqueLancado = ordem.isEstoqueLancado;
    if (temEstoqueLancado && !this.podeExcluirEstoque) {
      this.alertService.show('Atenção', 'Exclua o estoque antes de excluir esta ordem.', AlertType.warning);
      return;
    }

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Excluir ordem de produção',
        innerHtml: temEstoqueLancado
          ? `<p>A OP ${ordem.numero} será excluída. O histórico da ordem é preservado.</p>
             <p>Esta ordem possui <strong>estoque lançado</strong>. Ao confirmar, o estoque será excluído antes da ordem. Tem certeza que deseja prosseguir?
             </p>`
          : `<p>A OP ${ordem.numero} será excluída. O histórico da ordem é preservado. Tem certeza que deseja prosseguir?</p>`,
        showTextarea: temEstoqueLancado,
        textareaLabel: 'Justificativa da exclusão',
        textareaRequired: true,
        textareaMinLength: 10,
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result?.confirm) return;

      if (temEstoqueLancado) {
        const request = new OrdemProducaoEstoqueExcluirRequest();
        request.justificativa = result.textareaValue.trim();

        this._isLoading = true;
        this.ordemProducaoOrquestradorService.excluirEstoque(ordem.idOrdemProducao, request).subscribe({
          next: (res) => {
            if (res.isError) {
              this._isLoading = false;
              this.alertService.show('Erro', res.errorDescription, AlertType.error);
              this.clickPesquisar();
              return;
            }
            if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
            this.confirmarExclusao(ordem);
          },
          error: (err) => {
            this._isLoading = false;
            this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
            this.clickPesquisar();
          },
        });
        return;
      }

      this.confirmarExclusao(ordem);
    });
  }

  private confirmarExclusao(ordem: OrdemProducaoListStruct): void {
    this._isLoading = true;
    this.ordemProducaoService.excluir(ordem.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoading = false;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        // A API não exclui OP com estoque lançado: devolve a flag, sem erro (ex.: a exclusão do estoque não chegou a ser registrada).
        if (res.requerExclusaoEstoque) {
          this.alertService.show('Atenção', 'Exclua o estoque antes de excluir.', AlertType.warning);
          this.clickPesquisar();
          return;
        }

        this.alertService.show('Sucesso', 'Ordem de produção excluída.', AlertType.success);
        this.clickPesquisar();
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  /** "Lançar estoque" da linha: o mesmo diálogo individual do detalhe, que precisa da OP completa. */
  public lancarEstoque(ordem: OrdemProducaoListStruct): void {
    this.idOrdemProducaoEmAcao = ordem.idOrdemProducao;
    this.ordemProducaoOrquestradorService.getById(ordem.idOrdemProducao).subscribe({
      next: (res) => {
        this.idOrdemProducaoEmAcao = null;
        if (res.isError || !res.ordemProducao) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        const dialogRef = this.dialog.open(LancarEstoqueOrdemProducaoDialogComponent, {
          maxWidth: '760px',
          width: '95vw',
          data: { ordem: res.ordemProducao },
        });

        dialogRef.afterClosed().subscribe((request: LancarEstoqueOrdemProducaoItemRequest | undefined) => {
          if (!request) return;

          this.idOrdemProducaoEmAcao = ordem.idOrdemProducao;
          this.ordemProducaoOrquestradorService.lancarEstoque({ ordens: [request] }).subscribe({
            next: (resLancamento) => {
              this.idOrdemProducaoEmAcao = null;
              if (resLancamento.isError) {
                this.alertService.show('Erro', resLancamento.errorDescription, AlertType.error);
              } else {
                this.alertService.show('Sucesso', 'Estoque lançado.', AlertType.success);
                if (resLancamento.avisoDescricao) this.alertService.show('Atenção', resLancamento.avisoDescricao, AlertType.warning);
              }
              this.clickPesquisar();
            },
            error: (err) => {
              this.idOrdemProducaoEmAcao = null;
              this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
              this.clickPesquisar();
            },
          });
        });
      },
      error: (err) => {
        this.idOrdemProducaoEmAcao = null;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  public excluirEstoque(ordem: OrdemProducaoListStruct): void {
    const dialogRef = this.dialog.open(ExcluirEstoqueOrdemProducaoDialogComponent, {
      maxWidth: '520px',
      width: '95vw',
      disableClose: true,
      data: { idOrdemProducao: ordem.idOrdemProducao, numero: ordem.numero, nomeProduto: ordem.nomeProduto },
    });

    dialogRef.afterClosed().subscribe((justificativa: string | undefined) => {
      if (!justificativa) return;

      const request = new OrdemProducaoEstoqueExcluirRequest();
      request.justificativa = justificativa;

      this.idOrdemProducaoEmAcao = ordem.idOrdemProducao;
      this.ordemProducaoOrquestradorService.excluirEstoque(ordem.idOrdemProducao, request).subscribe({
        next: (res) => {
          this.idOrdemProducaoEmAcao = null;
          if (res.isError) {
            this.alertService.show('Erro', res.errorDescription, AlertType.error);
          } else {
            this.alertService.show('Sucesso', 'Estoque excluído.', AlertType.success);
            if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
          }
          this.clickPesquisar();
        },
        error: (err) => {
          this.idOrdemProducaoEmAcao = null;
          this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
          this.clickPesquisar();
        },
      });
    });
  }

  public lancarEstoqueEmLote(): void {
    if (!this.selection.hasValue()) return;

    const dialogRef = this.dialog.open(LancarEstoqueLoteOrdemProducaoDialogComponent, {
      maxWidth: '820px',
      width: '95vw',
      data: { ordens: this.selection.selected },
    });

    dialogRef.afterClosed().subscribe((sucesso: boolean | undefined) => {
      if (!sucesso) return;
      this.selection.clear();
      this.clickPesquisar();
    });
  }

  public alterarTagsEmLote(): void {
    if (!this.selection.hasValue()) return;

    const dialogRef = this.dialog.open(AlterarTagsOrdemProducaoDialogComponent, {
      maxWidth: '560px',
      width: '100%',
      data: {
        listaTags: this.listaTags,
        quantidadeSelecionada: this.selection.selected.length,
      },
    });

    dialogRef.afterClosed().subscribe((result: { listIdTagProducao: number[]; isIncluir: boolean } | undefined) => {
      if (!result) return;

      this._isLoading = true;
      this.ordemProducaoService
        .alterarTagsEmLote({
          listIdOrdemProducao: this.selection.selected.map((o) => o.idOrdemProducao),
          listIdTagProducao: result.listIdTagProducao,
          isIncluir: result.isIncluir,
        })
        .subscribe({
          next: (res) => {
            this._isLoading = false;

            if (res.isError) {
              this.alertService.show('Erro', res.errorDescription, AlertType.error);
              return;
            }

            this.alertService.show('Sucesso', 'Tags atualizadas.', AlertType.success);
            this.clickPesquisar();
          },
          error: (err) => {
            this._isLoading = false;
            this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
          },
        });
    });
  }

  public gerarOrdensRelacionadas(ordem: OrdemProducaoListStruct): void {
    this._isLoading = true;

    this.ordemProducaoOrquestradorService.gerarOrdensRelacionadas(ordem.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoading = false;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);

        // O diálogo aparece mesmo quando nada foi gerado (seção 6.3 da US).
        this.dialog
          .open(OrdensRelacionadasDialogComponent, {
            maxWidth: '620px',
            width: '95vw',
            data: {
              numeroOrigem: res.numeroOrdemProducaoOrigem,
              ordensGeradas: res.ordensGeradas ?? [],
              algumFabricadoEncontrado: res.algumFabricadoEncontrado,
            },
          })
          .afterClosed()
          .subscribe(() => {
            if ((res.ordensGeradas ?? []).length > 0) this.clickPesquisar();
          });
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  // ── Impressões (7.1 / 7.3) ──────────────────────────────────────────────────

  /**
   * "Necessidade de materiais" (seção 7.1). `ordem` presente = "⋮" da linha (1 OP). Sem `ordem` =
   * botão "Ações": com seleção, imprime as selecionadas; sem seleção, todas as OPs do filtro atual
   * (mesmo fora da página carregada).
   */
  public imprimir(ordem?: OrdemProducaoListStruct): void {
    if (this._isLoading) return;

    if (ordem) {
      this.buscarEAbrirImpressaoNecessidadeMateriais([ordem.idOrdemProducao]);
      return;
    }

    if (this.selection.hasValue()) {
      this.buscarEAbrirImpressaoNecessidadeMateriais(this.selection.selected.map((o) => o.idOrdemProducao));
      return;
    }

    this._isLoading = true;
    const request: OrdemProducaoListaRequest = { ...this.montarRequest(), tamanhoPagina: 9999 };
    this.ordemProducaoOrquestradorService.getAll(request, 0).subscribe({
      next: (res) => {
        this._isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        const lista = res.listaOrdemProducao ?? [];
        if (lista.length === 0) {
          this.alertService.show('Aviso', 'Nenhuma ordem de produção encontrada para os filtros atuais.', AlertType.warning);
          return;
        }
        this.buscarEAbrirImpressaoNecessidadeMateriais(lista.map((o) => o.idOrdemProducao));
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  private buscarEAbrirImpressaoNecessidadeMateriais(idsOrdemProducao: number[]): void {
    this._isLoading = true;
    const chamadas = idsOrdemProducao.map((id) => this.ordemProducaoOrquestradorService.getById(id));

    forkJoin(chamadas).subscribe({
      next: (respostas) => {
        this._isLoading = false;

        const ordens: OrdemProducaoDetalheStruct[] = [];
        for (const res of respostas) {
          if (!res.isError && res.ordemProducao) ordens.push(res.ordemProducao);
        }

        if (ordens.length === 0) {
          this.alertService.show('Erro', 'Não foi possível carregar as ordens de produção selecionadas.', AlertType.error);
          return;
        }

        this.dialog.open(ImpressaoNecessidadeMateriaisOrdemProducaoDialogComponent, {
          maxWidth: '900px',
          width: '95vw',
          data: { ordens },
        });
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  /**
   * "Imprimir Etiquetas" (seção 7.3) — só os produtos fabricados das OPs selecionadas (1 por SKU,
   * sem matérias-primas), abrindo o diálogo compartilhado já usado por Produtos e Controle de
   * Estoque. Cada linha nasce com quantidade 1 (mesmo comportamento do diálogo nos outros dois
   * lugares) — editável antes de imprimir.
   */
  public imprimirEtiquetas(): void {
    if (!this.selection.hasValue()) return;

    this._isLoading = true;
    this.etiquetaLookupService.listEtiquetaSelect().subscribe({
      next: (res) => {
        this._isLoading = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        if (!res.list || res.list.length === 0) {
          this.exibirAlertaSemConfiguracaoEtiqueta();
          return;
        }
        this.abrirModalImprimirEtiquetas(this.produtosFabricadosSelecionados(), res.list);
      },
      error: () => {
        this._isLoading = false;
        this.alertService.show('Erro', 'Falha ao verificar configurações de etiqueta.', AlertType.error);
      },
    });
  }

  private produtosFabricadosSelecionados(): ProdutoListStruct[] {
    const vistos = new Set<number>();
    const produtos: ProdutoListStruct[] = [];

    for (const ordem of this.selection.selected) {
      if (vistos.has(ordem.idProduto)) continue;
      vistos.add(ordem.idProduto);

      const item = new ProdutoListStruct();
      item.idProduto = ordem.idProduto;
      item.descricao = ordem.nomeProduto;
      item.codigoSku = ordem.codigoSku;
      item.unidade = ordem.unidade;
      item.isVariacao = false;
      item.qtdVariacoes = 0;
      item.isKit = false;
      item.isFabricado = true;
      item.isControlaLotes = false;
      item.isControlaSeries = false;
      item.idTipoProduto = 0;
      item.variacoes = [];
      produtos.push(item);
    }

    return produtos;
  }

  private abrirModalImprimirEtiquetas(listaProdutos: ProdutoListStruct[], listaConfiguracoes: EtiquetaLookupItemStruct[]): void {
    const dialogData: ImprimirEtiquetasDialogData = {
      listaProdutos,
      listaConfiguracoes,
      listaPrecos: this.listaPreco,
      listaLocalizacaoEstoque: this.listaLocalizacaoEstoque,
    };

    this.dialog.open(ImprimirEtiquetasDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: false,
      data: dialogData,
    });
  }

  private exibirAlertaSemConfiguracaoEtiqueta(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Configuração necessária',
        description:
          'Para imprimir as etiquetas é necessário realizar as configurações. Você pode fazer isso acessando Configurações > Configurações das etiquetas ou clicando no botão configurar etiquetas.',
        buttonConfirm: 'Configurar etiquetas',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirm) {
        this.router.navigate(['/configuracoes/gerais/etiquetas']);
      }
    });
  }
}
